import styled from 'styled-components';

const StyledWrapper = styled.div`
	opacity: 0;
	transition: opacity 0.5s ease 0.1s;
`;

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, calc(-50% - 5px));
	width: 460px;
	padding: 30px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 6px 80px rgba(0, 0, 0, 0.5);
	border-radius: 10px;
`;

export { StyledContainer, StyledWrapper };
